import editableFormControls from "./editableFormControls.component";

const editableFormControlsModule = angular
  .module("app.components.editableFormControls", [])
  .component("editableFormControls", editableFormControls);

export default editableFormControlsModule;



// WEBPACK FOOTER //
// ./src/components/editableFormControls/editableFormControls.module.js